export const white = '#FFFFFF';
export const black = '#000000';
export const darkGrey = '#3A3A3A';
export const grey = '#95B0BE';
export const teal = '#34BFC9';
export const lightTeal = '#ABF2ED';
export const magenta = '#D72270';
export const yellow = '#FFD166';
export const lightYellow = '#FFDE94';
export const lightYellowOpacity70 = '#FFDE94B3';
export const blue = '#118AB2';
export const lightBlue = '#58ACC8';
